import React, { useState } from "react";
import "../style/ServicesComponent.scss";

const services = [
  {
    id: "web-design",
    title: "Web Design",
    description: "We create beautiful, user-friendly websites that work on phones, tablets, and computers. Our designs match your brand and make your visitors feel at home.",
    icons: ['/tools/figma.svg', '/tools/Elementor.svg'],
    image: "logo/Web-Design.jpeg"
  },
  {
    id: "web-dev",
    title: "Web Development",
    description: "We build fast, modern websites and web apps using the latest technologies. Whether you need a landing page or a full online store, we’ve got you covered.",
    icons: [
      '/tools/html.svg', '/tools/css-3.svg', '/tools/javascript.svg', 
      '/tools/react.svg', '/tools/tailwind.svg', '/tools/sass.svg', 
      '/tools/nextjs.svg', '/tools/kotlin.svg'
    ],
    image: "logo/web-dev.jpeg"
  },
  /*
  {
    id: "web-maint",
    title: "Web Maintenance",
    description: "We take care of your website with regular updates, backups, bug fixes, and security checks so you can focus on your business without worry.",
    icons: ["/Tools/wordpress.svg", "/Tools/woocommerce.svg", "/Tools/webflow.svg"],
    image: "logo/search.png"
  },
  {
    id: "consulting",
    title: "Web Consulting",
    description: "Not sure where to start? We offer honest advice, custom strategies, and help choosing the right tools to grow your business online.",
    icons: ["/Tools/microsoft-teams.svg", "/Tools/zoom.svg", "/Tools/google-meets.svg"],
    image: "logo/search.png"
  },*/
  {
    id: "seo",
    title: "SEO",
    description: "We help people find your website on Google by improving content, speed, and structure. More visibility means more visitors — and more customers.",
    icons: ["/tools/google-search-console.svg", "/tools/google-tag-manager.svg"],
    image: "logo/seo.png"
  },
  {
    id: "social-media",
    title: "Social Media",
    description: "We manage your social media accounts and create posts that get attention. We help you grow your audience on Instagram, Facebook, TikTok, and more.",
    icons: ["/tools/facebook.svg", "/tools/instagram.svg", "/tools/tiktok.svg", "/tools/twitter.svg"],
    image: "logo/social-media.jpeg"
  },
  {
    id: "creative-content",
    title: "Creative Content",
    description: "We create content that tells your story — from videos for ads and events to photos and edited reels. Perfect for websites, campaigns, or social media.",
    icons: ["/tools/adobe-premiere.svg", "/tools/adobe-after-effects.svg", "/tools/adobe-photoshop.svg"],
    image: "logo/creative-content.png"
  }
];

const Services = () => {
  const [activeTab, setActiveTab] = useState("web-design");

  return (
    <div className="container-services">
      <h2 className="split-text">Our Services</h2>
      <div className="split-p">
      <p>
        We offer helpful digital services to grow your business online. From websites and design to SEO and smart advice — we’re here to make your life easier and your brand stronger.
      </p>
        </div>
      
      <div className="tabs">
        {services.map((service) => (
          <button
            key={service.id}
            className={`tab ${activeTab === service.id ? "active" : ""}`}
            onClick={() => setActiveTab(service.id)}
          >
            {service.title}
          </button>
        ))}
      </div>

      {services.map((service) => (
        <section
          key={service.id}
          className={`service-section ${activeTab === service.id ? "active" : ""}`}
        >
          <div className="service-content">
            <h2>
              <span>{services.indexOf(service) + 1} -</span> {service.title}
            </h2>
            <p>{service.description}</p>
            <div className="icons">
              {service.icons.map((icon, index) => (
                <img key={index} src={icon} alt={service.title} />
              ))}
            </div>
          </div>
          <div className="service-image">
            <img src={service.image} alt={service.title} />
          </div>
        </section>
      ))}
    </div>
  );
};

export default Services;
